import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router';
import { useBundle } from '@amzn/react-arb-tools';
import Alert from '@amzn/meridian/alert';
import Text from '@amzn/meridian/text';
import Heading from '@amzn/meridian/heading';
import Column from '@amzn/meridian/column';
import { ReportActionSource } from '@amzn/handshake-painter-typescript-client/v1';
import { RetailRoutes, useRetailRedirectUrls } from 'src/utils/links';
import { getMarketplace } from 'src/utils/marketplace';
import { useAnalyticsContext } from 'src/common/metrics';
import { Link } from 'src/common/styled';
import { useOffRampToAmazon } from 'src/hooks/useOffRampToAmazon';
import { Loading } from '../loaders/Loading';
/**
 * Error page for invalid routing in the application
 * Converted from: https://code.amazon.com/packages/HandshakePainterComponents/blobs/mainline/--/src/kata/templates/error/DogPage.kata
 */
export const DogPage = () => {
    const [bundle, isBundleLoading] = useBundle('pages.dogPage');
    const rumClient = useAnalyticsContext();
    const redirectUrls = useRetailRedirectUrls([RetailRoutes.DETAIL_PAGE]);
    const offRampToAmazon = useOffRampToAmazon();
    const { asin } = useParams();
    const [searchParams] = useSearchParams();
    const marketplaceId = getMarketplace(searchParams);
    // Only fire RUM events on mount
    useEffect(() => {
        rumClient.recordEvent('DOG_PAGE', {
            asin,
            marketplaceId,
        });
    }, []);
    if (isBundleLoading) {
        return _jsx(Loading, {});
    }
    const openExternalLink = (e) => {
        e.preventDefault();
        offRampToAmazon(e.currentTarget.href, ReportActionSource.DogPage);
    };
    const alertMsgLink = (chunk) => (_jsx(Link, { underline: true, href: redirectUrls.DETAIL_PAGE, onClick: openExternalLink, "data-testid": "detail-page-link", children: chunk }, chunk));
    const alertMsg = asin
        ? bundle.formatMessage('tryAgainLaterOrViewOnAmazon', { a: alertMsgLink })
        : bundle.getMessage('tryAgainLater');
    return (_jsxs(Column, { spacingInset: "300 400", spacing: "200", "data-testid": "dog-page", children: [_jsxs(Alert, { type: "error", "data-testid": "error-message", children: [_jsx(Heading, { level: 3, type: "b200", children: _jsx("b", { children: bundle.getMessage('somethingWentWrong') }) }), _jsx(Text, { type: "b200", children: _jsx("span", { children: alertMsg }) })] }), _jsx("img", { src: "https://m.media-amazon.com/images/G/01/ShopExternal/images/dogs/jake_1_transparent._CB583692400_.png", alt: bundle.getMessage('dogName'), "data-testid": "dog-image" }), _jsx(Text, { type: "b200", alignment: "center", children: bundle.getMessage('dogName') }), _jsx(Text, { type: "b200", alignment: "center", children: _jsx(Link, { onClick: openExternalLink, href: "https://www.amazon.com/dogsofamazon", "data-testid": "meet-dogs-link", children: bundle.getMessage('meetTheDogsOfAmazon') }) })] }));
};
